// Case Overview
// -------------
import {Power1, TweenLite} from 'gsap';

(function ($) {
    const $body = $('body');

    $.fn.caseOverview = function (options) {
        var settings = $.extend({}, {
            duration: 0.6,
            fallbackFactor: 3 // Allow x times the animation duration to trigger the fallback
        }, options);

        return this.each(function () {
            const $container = $(this),
                $cases = $container.find('.card-case'),
                $overlay = $container.find('.case-overlay-container');
            let fallbackTimeout = null;

            function prerenderUri(uri) {
                const prerenderLink = document.createElement('link');
                prerenderLink.rel = 'prerender';
                prerenderLink.as = 'document';
                prerenderLink.href = uri;
                prerenderLink.type = 'text/html';
                document.head.appendChild(prerenderLink);
            }

            function animateCase(caseElement, uri) {
                const $fromHeader = $(caseElement).find('header'),
                    $clone = $fromHeader.clone(),
                    $toHeader = $fromHeader.clone().appendTo($overlay).addClass('case-header'),
                    from = $fromHeader.offset(),
                    to = $toHeader.offset();

                $body.addClass('tile-active');

                TweenLite.set([$fromHeader, $toHeader], { visibility: 'hidden' });
                TweenLite.set($clone, { position: 'absolute', margin: 0 });

                $clone.appendTo($body);

                const style = {
                    x: to.left - from.left,
                    y: to.top - from.top,
                    width: $toHeader.width(),
                    height: $toHeader.height(),
                    autoRound: false,
                    ease: Power1.easeIn,
                    onComplete: function () {
                        clearInterval(fallbackTimeout);
                        window.location.href = uri;
                    }
                };

                TweenLite.set($clone, $.extend(from, {width: $fromHeader.width(), height: $fromHeader.height()}));
                TweenLite.to($clone, settings.duration, style);

                // Cleanup, needed for Safari back-button
                $(window).bind('pagehide', function () {
                    $clone.remove();
                    $toHeader.remove();
                    $body.removeClass('tile-active');
                    TweenLite.set([$fromHeader], { visibility: 'visible' });
                });
            }

            $cases.each(function () {
                const $link = $(this).find('.case-link');

                $link.bind('click', function (evt) {
                    $('.page-header').addClass('case-animation-active');
                    evt.preventDefault();
                    const href = $(this).attr('href');
                    animateCase(this, href);
                    prerenderUri(href);
                    fallbackTimeout = setTimeout(function () {
                        window.location.href = href;
                    }, settings.duration * settings.fallbackFactor * 1000); // Will call the function after 1 sec.
                });
            });
        });
    };

    $(function () {
        $('.case-overview').caseOverview();
    });
})(jQuery);
